import { render, staticRenderFns } from "./OpenDoor.vue?vue&type=template&id=483531ad&scoped=true&"
import script from "./OpenDoor.vue?vue&type=script&lang=js&"
export * from "./OpenDoor.vue?vue&type=script&lang=js&"
import style0 from "./OpenDoor.vue?vue&type=style&index=0&id=483531ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483531ad",
  null
  
)

export default component.exports